/** Spinner while a lazy route's chunk loads. `inPage`: fills the app's main area instead of the whole viewport. */
export default function RouteFallback({ inPage = false }: { inPage?: boolean }) {
  return (
    <div className={`flex ${inPage ? "h-full min-h-[50vh]" : "h-dvh"} w-full items-center justify-center`}>
      <svg
        className="animate-spin text-muted-foreground"
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-label="Loading"
      >
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
    </div>
  );
}
